import axios from 'axios';
import { ElNotification, ElMessageBox } from 'element-plus';
// 引入 ElLoading
import { ElLoading } from 'element-plus';
import sysConfig from "@/config";
import tool from '@/utils/tool';
import router from '@/router';
import config from "@/config"

axios.defaults.baseURL = ''

axios.defaults.timeout = sysConfig.TIMEOUT

// HTTP request 拦截器
axios.interceptors.request.use(
	(config) => {

		let token = tool.cookie.get("TOKEN");
		if (token) {
			config.headers[sysConfig.TOKEN_NAME] = sysConfig.TOKEN_PREFIX + token
		}
		else {

			router.replace({ path: '/login' });
		}

		let tenantId = tool.cookie.get("TenantId");
		if (tenantId) {
			config.headers[sysConfig.TenantId_Name] = tenantId
		}
		else {

			router.replace({ path: '/login' });
		}


		let expiresIn = tool.cookie.get("ExpiresIn");

		if (expiresIn) {
			let now = Date.now();
			if (expiresIn < now) {
				this.$TOOL.cookie.set("ExpiresIn", "");
				router.replace({ path: '/login' });
			}
		}
		else {

			router.replace({ path: '/login' });
		}

		//每一个小时获取用户是否被锁定

		if (!sysConfig.REQUEST_CACHE && config.method == 'get') {
			config.params = config.params || {};
			config.params['_'] = new Date().getTime();
		}
		Object.assign(config.headers, sysConfig.HEADERS)
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

//FIX 多个API同时401时疯狂弹窗BUG
let MessageBox_401_show = false

// 用于防止重复弹出多个 loading
let maintenanceLoading = null;
let retryTimer = null;
const RETRY_INTERVAL = 8000;           // 每 8 秒尝试一次重连检测
const PING_URL = `${config.API_URL}/api/app/user`;          // 建议后端提供轻量 ping 接口，没有的话可改成任意稳定 GET 接口如 /api/health 或 /
const PING_TIMEOUT = 5000;

// HTTP response 拦截器
axios.interceptors.response.use(
	(response) => {
		// 成功响应时，如果有 maintenance loading 就关闭（以防万一）
		if (maintenanceLoading) {
			maintenanceLoading.close();
			maintenanceLoading = null;
		}
		clearTimeout(retryTimer);

		return response;
	},
	(error) => {
		console.log(error)
		if (error.response) {
			if (error.response.status == 404) {
				ElNotification.error({
					title: '请求错误',
					message: "Status:404，正在请求不存在的服务器记录！"
				});
			} else if (error.response.status == 500) {
				ElNotification.error({
					title: '请求错误',
					message: error.response.data.error.message || "Status:500，服务器发生错误！"
				});
			} else if (error.response.status == 401) {
				if (!MessageBox_401_show) {
					MessageBox_401_show = true
					ElMessageBox.confirm('当前用户已被登出或无权限访问当前资源，请尝试重新登录后再操作。', '无权限访问', {
						type: 'error',
						closeOnClickModal: false,
						center: true,
						confirmButtonText: '重新登录',
						beforeClose: (action, instance, done) => {
							MessageBox_401_show = false
							done()
						}
					}).then(() => {
						router.replace({ path: '/login' });
					}).catch(() => { })
				}
			} else {
				ElNotification.error({
					title: '请求错误',
					message: error.response.data.error.details || error.response.data.error.message || `Status:${error.response.status}，未知错误！`
				});
			}
		} else {
			// ────────────── 网络层失败（连不上、超时、断网等） ──────────────
			// 弹出全屏维护 loading（只弹一次）
			if (!maintenanceLoading) {
				maintenanceLoading = ElLoading.service({
					lock: false,
					text: '服务器去火星了????请稍等，马上返回地球~~~到达时间可能是60秒后',
					background: 'rgba(0, 0, 0, 0.7)',
					// 可选：customClass: 'maintenance-loading'
				});

				// 自动重试检测函数
				const tryReconnect = () => {
					axios.get(PING_URL, { timeout: PING_TIMEOUT })
						.then(() => {
							// 成功 → 关闭 loading
							if (maintenanceLoading) {
								maintenanceLoading.close();
								maintenanceLoading = null;
							}
							clearTimeout(retryTimer);
							retryTimer = null;

							ElNotification.success({
								title: '连接恢复',
								message: '服务器已恢复正常，继续操作吧～',
								duration: 4000
							});
						})
						.catch(() => {
							// 失败 → 继续定时重试
							retryTimer = setTimeout(tryReconnect, RETRY_INTERVAL);
						});
				};

				// 立即尝试一次
				tryReconnect();

				setTimeout(() => {
					if (maintenanceLoading) {
						maintenanceLoading.close();
						maintenanceLoading = null;

						// ★★★ 关键：停止自动重试
						if (retryTimer) {
							clearTimeout(retryTimer);
							retryTimer = null;
						}

						window.location.replace('#/login');
						// ElMessageBox.alert(
						// 	'服务器恢复似乎还需要一点时间呢～\n你可以先做其他事情，稍后再刷新页面试试。',
						// 	'等待超时',
						// 	{
						// 		confirmButtonText: '好的，我知道了',
						// 		type: 'warning',
						// 		center: true,
						// 	}
						// ).then(() => {

						// });
					}
				}, 60000);  // 或改回 60000

			}

			// 仍然 reject，让调用方知道失败（但界面已被 loading 接管）
			// 你也可以在这里不弹 ElNotification 了，因为 loading 已显示
		}

		return Promise.reject(error.response);
	}
);

var http = {

	/** get 请求
	 * @param  {string} url 接口地址
	 * @param  {object} params 请求参数
	 * @param  {object} config 参数
	 */
	get: function (url, params = {}, config = {}) {
		return new Promise((resolve, reject) => {
			axios({
				method: 'get',
				url: url,
				params: params,
				...config
			}).then((response) => {
				resolve(response.data);
			}).catch((error) => {
				reject(error);
			})
		})
	},

	/** post 请求
	 * @param  {string} url 接口地址
	 * @param  {object} data 请求参数
	 * @param  {object} config 参数
	 */
	post: function (url, data = {}, config = {}) {
		return new Promise((resolve, reject) => {
			axios({
				method: 'post',
				url: url,
				data: data,
				...config
			}).then((response) => {
				resolve(response.data);
			}).catch((error) => {
				reject(error);
			})
		})
	},

	/** put 请求
	 * @param  {string} url 接口地址
	 * @param  {object} data 请求参数
	 * @param  {object} config 参数
	 */
	put: function (url, data = {}, config = {}) {
		return new Promise((resolve, reject) => {
			axios({
				method: 'put',
				url: url,
				data: data,
				...config
			}).then((response) => {
				resolve(response.data);
			}).catch((error) => {
				reject(error);
			})
		})
	},

	/** patch 请求
	 * @param  {string} url 接口地址
	 * @param  {object} data 请求参数
	 * @param  {object} config 参数
	 */
	patch: function (url, data = {}, config = {}) {
		return new Promise((resolve, reject) => {
			axios({
				method: 'patch',
				url: url,
				data: data,
				...config
			}).then((response) => {
				resolve(response.data);
			}).catch((error) => {
				reject(error);
			})
		})
	},

	/** delete 请求
	 * @param  {string} url 接口地址
	 * @param  {object} data 请求参数
	 * @param  {object} config 参数
	 */
	delete: function (url, params = {}, config = {}) {

		return new Promise((resolve, reject) => {
			axios({
				method: 'delete',
				url: url,
				params: params,
				...config
			}).then((response) => {
				resolve(response.data);
			}).catch((error) => {
				reject(error);
			})
		})
		// return new Promise((resolve, reject) => {
		// 	axios({
		// 		method: 'delete',
		// 		url: url,
		// 		data: data,
		// 		...config
		// 	}).then((response) => {
		// 		resolve(response.data);
		// 	}).catch((error) => {
		// 		reject(error);
		// 	})
		// })
	},

	/** jsonp 请求
	 * @param  {string} url 接口地址
	 * @param  {string} name JSONP回调函数名称
	 */
	jsonp: function (url, name = 'jsonp') {
		return new Promise((resolve) => {
			var script = document.createElement('script')
			var _id = `jsonp${Math.ceil(Math.random() * 1000000)}`
			script.id = _id
			script.type = 'text/javascript'
			script.src = url
			window[name] = (response) => {
				resolve(response)
				document.getElementsByTagName('head')[0].removeChild(script)
				try {
					delete window[name];
				} catch (e) {
					window[name] = undefined;
				}
			}
			document.getElementsByTagName('head')[0].appendChild(script)
		})
	}
}

export default http;
